'use client';

import React from 'react';
import { useForm } from 'react-hook-form';
import { useRouter } from 'next/navigation';
import { AppSelectInput } from '../formFields';
import styles from './styles.module.scss';
import { constructClassName } from '../../utils/constructClassName';

interface Props {
  services?: {
    title: string;
    slug: string;
    shortTitle?: string;
  }[]
}

export const ClientServiceSelect: React.FC<Props> = ({
  services,
}) => {
  const { control } = useForm();
  const router = useRouter();

  return (
    <form
      onSubmit={() => { }}
      className={constructClassName([
        styles.container,
      ])}
    >
      <span>I Am Looking For</span>
      <AppSelectInput
        control={control}
        name="service"
        label="Service"
        options={services?.map((service) => ({
          label: service.shortTitle || service.title,
          value: service.slug,
        }))}
        onChange={(value) => {
          router.push(`/services/${value}`);
        }}
        placeholder="Select Service"
        hideLabel
      />
    </form>
  );
};
